import { render } from "./NavBarMenuDivider.vue?vue&type=template&id=42c93416"
import script from "./NavBarMenuDivider.vue?vue&type=script&lang=js"
export * from "./NavBarMenuDivider.vue?vue&type=script&lang=js"

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__